<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 8C2 7.44772 2.5 7 3 7H13C13.5 7 14 7.44772 14 8C14 8.55228 13.5 9 13 9H3C2.5 9 2 8.55228 2 8Z"
    fill="currentColor"
  />
</svg>
